import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/pgt";
import { Loader2, ScrollText } from "lucide-react";

const ACTION_TONE = {
  login: "text-stone-500",
  create_customer: "text-forest",
  confirm_sent: "text-whatsapp-dark",
  record_response: "text-blue-600",
  archive_customer: "text-red-600",
  generate_message: "text-gold",
};

export default function Audit() {
  const { data: logs = [], isLoading } = useQuery({
    queryKey: ["audit"],
    queryFn: async () => (await api.get("/audit")).data,
  });

  return (
    <div className="animate-fade-up">
      <div className="mb-5">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-stone-900">Audit log</h1>
        <p className="mt-1 text-sm text-stone-500">A record of key actions across the team.</p>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-20"><Loader2 className="h-7 w-7 animate-spin text-forest" /></div>
      ) : logs.length === 0 ? (
        <div className="rounded-xl border border-dashed border-stone-300 bg-white/50 py-16 text-center">
          <ScrollText className="mx-auto h-10 w-10 text-stone-300" />
          <p className="mt-3 text-sm text-stone-500">No audit entries yet.</p>
        </div>
      ) : (
        <div className="rounded-xl border border-stone-200 bg-white overflow-hidden" data-testid="audit-table">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-stone-200 bg-stone-50 text-left text-xs uppercase tracking-wide text-stone-400">
                <th className="px-4 py-2.5">Time</th>
                <th className="px-4 py-2.5">User</th>
                <th className="px-4 py-2.5">Action</th>
                <th className="px-4 py-2.5 hidden sm:table-cell">Details</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-stone-100">
                  <td className="px-4 py-2.5 text-xs text-stone-400 whitespace-nowrap">{fmtDateTime(l.created_at)}</td>
                  <td className="px-4 py-2.5"><span className="font-medium text-stone-800">{l.user_name}</span><span className="ml-1 text-[10px] text-stone-400">{l.user_role}</span></td>
                  <td className={`px-4 py-2.5 font-medium ${ACTION_TONE[l.action] || "text-stone-600"}`}>{l.action}</td>
                  <td className="px-4 py-2.5 text-stone-500 hidden sm:table-cell">{l.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
